import { SCAN_SECTION_KEY } from "../../enums/scan";
import { TovAuthoringPanel } from "../tov/TovAuthoringPanel";
import { createWebsiteStore } from "../website/store";
import { ScanRouteSurface } from "./ScanRouteChrome";
import { ScanRouteHeader } from "./ScanRouteHeader";
import { ScanShell } from "./ScanShell";
import { useBrandAuthoring } from "./useBrandAuthoring";

export function ScanBrandAuthoring(props: { websiteId: string }) {
  const context = createWebsiteStore(props.websiteId);
  const clientId = () => context.data()?.site.clientId ?? undefined;
  const clientName = () => context.data()?.site.clientName ?? "this client";
  const authoring = useBrandAuthoring({ clientId, clientName });

  return (
    <ScanShell context={context} active={SCAN_SECTION_KEY.BRAND_GUIDELINES}>
      <ScanRouteSurface class="signal-brand-authoring-route">
        <ScanRouteHeader
          websiteId={props.websiteId}
          section="Brand Guidelines"
          title="Manage Brand Guidelines"
          subtitle={`This Tone of Voice is shared across all websites for ${clientName()}.`}
          actions={
            <a
              class="scan-link"
              href={`/w/${props.websiteId}/scan/brand-guidelines`}
            >
              Back to Brand Guidelines
            </a>
          }
        />
        <TovAuthoringPanel authoring={authoring} />
      </ScanRouteSurface>
    </ScanShell>
  );
}
